import { useDashboardQuery, useMeQuery } from '@Store/api'

import ProductsSidebarLoading from './ProductsSidebarLoading'
import OutOfStock from '../dashboard/out-of-stock'
import PriceChanges from '../dashboard/price-changes'
import PricePositionCard, {
  SUMMARY_PRICE_POSITION_EVENTS,
} from '../dashboard/price-position/card'

function ProductsSidebar(): JSX.Element {
  const { data: dashboardData, isLoading: isDashboardDataLoading } =
    useDashboardQuery()
  const { currentData: user, isLoading: isUserLoading } = useMeQuery()

  if (isUserLoading || isDashboardDataLoading) {
    return <ProductsSidebarLoading />
  }

  return (
    <>
      <div className="pb-4">
        <PriceChanges changes={dashboardData?.price_changes} view="Products" />
      </div>
      <div className="pb-4">
        <OutOfStock
          outOfStock={dashboardData?.out_of_stock}
          company={user}
          view="Products"
        />
      </div>
      <div>
        <PricePositionCard
          position={dashboardData?.position}
          view="Products"
          compact
          eventNames={SUMMARY_PRICE_POSITION_EVENTS}
        />
      </div>
    </>
  )
}

export default ProductsSidebar
